var map = {
	"./1.json": [
		"./src/game/levels/1.json",
		"src_game_levels_1_json"
	],
	"./test 1.json": [
		"./src/game/levels/test 1.json",
		"src_game_levels_test_1_json"
	],
	"./test 2.json": [
		"./src/game/levels/test 2.json",
		"src_game_levels_test_2_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/game/levels lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;